export const LOCAL_TENANT = process.env.REACT_APP_LOCAL_TENANT || "test";
const DEFAULT_BACKEND_URL =
  LOCAL_TENANT === "test"
    ? process.env.REACT_APP_BACKEND_URL_SANDBOX
    : process.env.REACT_APP_BACKEND_URL_DEV;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || DEFAULT_BACKEND_URL || "";
// TODO: Invoke gateway url
export const BUCKET =
  process.env.REACT_APP_BUCKET || "praxispro-tenant-profiles-dev";
export const REGION = process.env.REACT_APP_REGION || "us-east-1";
export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "";
export const LICENSE_API_KEY = process.env.REACT_APP_LICENSE_API_KEY || "";
export const CHATBOT_BOT_ID = process.env.REACT_APP_CHATBOT_BOT_ID || "";
export const CHATBOT_BOT_ALIAS_ID = process.env.REACT_APP_CHATBOT_BOT_ALIAS_ID || "";
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "support@praxispro.ai"

// Firebase
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY || "";
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "";
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || "";
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "";
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "";
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID || "";
export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

// Datadog - Logs
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "";
// Datadog - RUM (separate RUM application)
export const DATADOG_RUM_APPLICATION_ID = process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID || "";
export const DATADOG_RUM_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN || "";
// Set to any non-empty value in .env.local to ship logs to Datadog from a local dev environment
export const SEND_DD_LOGS_DEV = process.env.REACT_APP_SEND_DD_LOGS_DEV || "";

// Opt-in switch for test-environment-only behaviour (e.g. `feature-<id>.*`
// deploys sending `X-Feature`). Set to "true" on sandbox and dev; left unset
// in prod so those code paths can never activate there.
export const TEST_ENVS_OPT_IN = process.env.REACT_APP_TEST_ENVS_OPT_IN === "true";